module.exports = __webpack_public_path__ + "static/oea-logo-cd815dbb0fc9094a58d1607d1193e251.png";